/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useCallback, useMemo, useRef, useState } from 'react';
import Grid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';

export default function GridExample(props) {
  const {
    fullScreenView,
    setFullScreenView,
    onCellClicked,
    setProcessID,
    setSucessMessage,
    setBussinessCheckBox,
    setShowDetailCheckBox,
    data,
    onSelect,
    cellHead,
  } = props;
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(gridRef);
  const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
  const [showViewHistory, setShowViewHistory] = useState(false);
  const [keyValue, setKeyValue] = useState([]);

  const onSelectionChanged = useCallback((params) => {
    setGridApi(params.api);
    const selectedRow =
      params.api && params.api.getSelectedNodes
        ? params.api.getSelectedNodes()
        : null;
    if (selectedRow && selectedRow.length > 0) {
      onCellClicked({ processId: selectedRow[0].data.processId });
      setProcessID(selectedRow[0].data.processId);
    }
    setSucessMessage([]);
    setBussinessCheckBox(true);
    setShowDetailCheckBox(false);
  }, []);

  const handleFullScreenViewClick = () => {
    setFullScreenView(!fullScreenView);
  };

  const handleViewHistory = () => {
    const selectedRow = gridApi.getSelectedRows()?.[0].processId;
    if (selectedRow !== undefined) {
      setShowViewHistory(true);
      setKeyValue({ PROCESS_ID: selectedRow });
    }
  };

  const onGridReady = (params) => {
    const { api } = params;
    const firstRowNode = api.getRowNode(0); // Get the first row node
    if (firstRowNode) {
      firstRowNode.setSelected(true); // Select the first row
    }
  };

  return (
    <div style={containerStyle}>
      <Grid
        onGridReady={onGridReady}
        gridHeight={fullScreenView ? '100vh' : 350}
        rowData={data}
        columnDefs={cellHead}
        data-testid="onEditingStopped"
        enterMovesDown
        suppressCellFocus
        noGlobalSort
        onCellFocused={onCellFocused}
        singleClickEdit={false}
        navigateToNextCell={navigateToNextCell}
        tabToNextCell={tabToNextCell}
        onSelect={onSelect ? onSelectionChanged : null}
        fullScreenView={fullScreenView}
        handleFullScreenViewClick={handleFullScreenViewClick}
        exportFile
        //handleViewHistory={handleViewHistory}
        fileName="Procedure Result"
      />
      {showViewHistory ? (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName="PROCESS_HEADER"
          keyValue={keyValue}
        />
      ) : null}
    </div>
  );
}
